<script setup lang="ts">
/**
 * PUT /data-objects/{id}/knowledge-bases/{kbId} from the collection's side. A collection holds one
 * document's projection, so the dialog opens only for an empty collection and asks for the one
 * ready document to project; the server projects its current revision as it stands.
 */
import Dialog from '~/components/ui/Dialog.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'
import Choice from '~/components/ui/Choice.vue'
import PickList from '~/components/ui/PickList.vue'

defineProps<{ collection: string; documents: { id: string; name: string; facts: string }[] }>()
const emit = defineEmits<{ close: []; submit: [payload: { dataObjectId: string }] }>()
const picked = ref('')
</script>

<template>
  <Dialog title="Add a document" :meta="collection" :width="560" @close="emit('close')">
    <template #icon><Icon name="memory" /></template>
    <p v-if="!documents.length" class="m-0 text-xs text-muted-foreground">No document is ready to be projected yet. A document becomes ready once it has been read and admitted.</p>
    <template v-else>
      <p class="m-0 text-xs text-muted-foreground">A collection holds one document's projection. The document's current revision is projected as it stands.</p>
      <PickList v-slot="{ shown }" :items="documents" unit="ready documents" :chosen="picked ? 1 : undefined" nothing="No document matches.">
        <Choice v-for="entry in shown" :key="entry.id" :title="entry.name" :facts="entry.facts" :selected="picked === entry.id" @click="picked = entry.id" />
      </PickList>
    </template>
    <template #actions>
      <ActionButton label="Cancel" @click="emit('close')" />
      <ActionButton label="Project document" variant="primary" :disabled="!picked" @click="emit('submit', { dataObjectId: picked })"><template #icon><Icon name="memory" /></template></ActionButton>
    </template>
  </Dialog>
</template>
